import { Moment } from 'moment';
import { convertDateToIsoString, convertIso8601ToDate } from '@app/shared/date-helpers.service';

export class ConcreteQuote {
  id: number;
  cartageRate: number;
  freeShortLoadId: number;
  nonworkdayChargeFlag: boolean;
  object: string;
  priceAdjustment: number;
  priceAdjustmentPercentFlag: boolean;
  printMaterialTypeId: number;
  requireOnSiteQC: boolean;
  salesmanEmployeeId: number;
  salesPlantId: number;
  shortLoadTypeId: number;
  standbyChargeTypeId: number;
  standbyMinPerQty: number;
  standbyPrice: number;
  termsDiscountId: number;

  private _startDate: Moment;
  get startDate(): Moment {
    return this._startDate;
  }
  set startDate(val) {
    this._startDate = convertIso8601ToDate(val);
  }

  private _terminationDate: Moment;
  get terminationDate(): Moment {
    return this._terminationDate;
  }
  set terminationDate(val) {
    this._terminationDate = convertIso8601ToDate(val);
  }

  toJSON(): Object {
    return convertDateToIsoString(this);
  }
}
